import React from "react";
import EditCredit from "./EditCredit";
import IncreaseCredit from "./IncreaseCredit";
import CreditPayments from "./CreditPayments";
import CreditComments from "./CreditComments";
import ProlongateCredit from "./ProlongateCredit";
import DecreaseCredit from "./DecreaseCredit";
import CloseCredit from "./CloseCredit";
import SwipeableViews from "react-swipeable-views";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

class CreditActive extends React.Component {

    state = {
        value: 0
    };

    switchTab = (e, value) => this.setState({ value });

    render() {
        const { value } = this.state;
        const { credit, updateCredit } = this.props;
        const { side } = credit;
        const tabs = [
            { label: "Платежи", icon: <PersonAddIcon /> },
            { label: "Заметки", icon: <PersonAddIcon /> },
            { label: "Редактировать", icon: <PersonAddIcon /> },
            { label: {"CREDIT": "Принять проценты", "DEBIT": "Выплатить проценты"}[side], icon: <ExitToAppIcon /> },
            { label: "Увеличить сумму", icon: <PersonAddIcon /> },
            { label: "Уменьшить сумму", icon: <PersonAddIcon /> },
            { label: "Закрыть", icon: <ExitToAppIcon /> }
        ];

        return (
            <React.Fragment>
                <Tabs value={value}
                      onChange={this.switchTab}
                      centered >
                    {tabs.map((tab, i) => <Tab key={i}
                                               label={tab.label}
                                               icon={tab.icon} />
                    )}
                </Tabs>
                <SwipeableViews axis="x" index={value}>
                    <div dir="x">
                        {value === 0 && <CreditPayments credit={credit} /> }
                    </div>
                    <div dir="x">
                        {value === 1 && <CreditComments credit={credit} updateCredit={updateCredit}/> }
                    </div>
                    <div dir="x">
                        {value === 2 && <EditCredit credit={credit} updateCredit={updateCredit} /> }
                    </div>
                    <div dir="x">
                        {value === 3 && <ProlongateCredit credit={credit} updateCredit={updateCredit} /> }
                    </div>
                    <div dir="x">
                        {value === 4 && <IncreaseCredit credit={credit} updateCredit={updateCredit} /> }
                    </div>
                    <div dir="x">
                        {value === 5 && <DecreaseCredit credit={credit} updateCredit={updateCredit} /> }
                    </div>
                    <div dir="x">
                        {value === 6 && <CloseCredit credit={credit} updateCredit={updateCredit} /> }
                    </div>
                </SwipeableViews>
            </React.Fragment>
        );
    }
}

export default CreditActive;



// WEBPACK FOOTER //
// ./src/components/CreditActive.js